export default {
    serverURI: "https://foxservice.net/api",
    // serverURI: "http://localhost:3002/api",
    // serverURI: "http://192.168.40.115:3002/api",
    // serverURI: "https://servi99v2.foxservice.net/api",
    fixedLayout: false,
    hideLogoOnMobile: false
};
